module.exports = __webpack_public_path__ + "img/H01046-03.c8a78fdb.jpg";